import { render } from "./RecipeIntroduce.vue?vue&type=template&id=56f609b2&scoped=true"
import script from "./RecipeIntroduce.vue?vue&type=script&lang=js"
export * from "./RecipeIntroduce.vue?vue&type=script&lang=js"

import "./RecipeIntroduce.vue?vue&type=style&index=0&id=56f609b2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/todaymeal_front/todaymeal_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f609b2"]])

export default __exports__